import { useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagem, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';
import { usePreenchimentoContext } from 'pages/financeiro/dre/preenchimento/contexts';
import { PreenchimentoDetail } from 'pages/financeiro/dre/preenchimento/types';

export function useQueryPreenchimento() {
    const { filter, page, limit, autoLoad } = useListagemContext();
    const requestListagem = useRequestListagem();
    const { setHasData } = usePreenchimentoContext();

    const requestOptions: RequestOptionsType = {
        url: '/dre/dremercadologica/relatoriopreenchimento',
        columns: 'idLoja,cdLoja,dsNomeFantasia,dtInicio,dtFim,idDreStatus,dsDreStatus,dsPeriodo,dhAlteracao',
        sort: [{ property: 'dtInicio', direction: 'ASC' }],
        filter,
        page,
        limit,
    };

    return useQuery<RequestListagem<PreenchimentoDetail[]>>(
        ['queryPreenchimento', requestOptions],
        () => requestListagem(requestOptions).then((res) => res.data.data),
        {
            enabled: autoLoad,
            onSettled: (data) => setHasData(Boolean(data?.total)),
        },
    );
}
